import { f as r } from "./fails.js";
import { i as s } from "./is-object.js";
import { c as o } from "./classof-raw.js";
import { a as e } from "./array-buffer-non-extensible.js";
var t = Object.isExtensible,
  a = r(function () {
    t(1);
  }) || e ? function (r) {
    return !!s(r) && (!e || "ArrayBuffer" != o(r)) && (!t || t(r));
  } : t;
export { a as o };